<template>
  <div>
    <v-form v-if="$auth.currentUser.isAdmin" @submit.prevent="submit">
      <v-layout row>
        <v-flex>
          <v-text-field
            :error-messages="errors.slug"
            @focus="errors.slug = null"
            v-model="slug"
            label="Artist slug"
            required
          />
        </v-flex>
        <v-flex pl-0 shrink>
          <tk-btn :loading="loading" :disabled="!slug" type="submit" color="primary">
            <span>Impersonate</span>
          </tk-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errors: {},
      slug: null,
      loading: false
    };
  },

  methods: {
    async submit() {
      console.log("submit");

      this.loading = true;

      try {
        await this.$auth.impersonate(this.slug);
        this.$emit("success", { slug: this.slug });
      } catch (error) {
        console.log("Error on impersonate", error);

        const message = error.data ? error.data.message : error.message;

        this.$app.toast(message, 5000, "error");
      }

      this.loading = false;
    }
  }
};
</script>

<style>
</style>